import { deviceWidth } from '@/utils/deviceWidth';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Modal from '../Common/Modal';

const BankOfferModal = (props) => {
  const { paymentOffersList } = useSelector((state) => ({
    paymentOffersList: state.promoReducer.paymentOffersList,
  }));

  useEffect(() => {
    if (props.open) {
      document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
    } else {
      document.getElementsByTagName('body')[0].style.overflowY = '';
    }
  }, [props.open]);

  return (
    <Modal
      visible={props.open}
      customStyles={{
        padding: 0,
        maxWidth: 672,
        maxHeight: deviceWidth <= 766 ? '90vh' : 'auto',
        maxHeight: '600px',
        height: '100%',
        overflowY: 'auto',
      }}
      animation={'slideUp'}
      className="bottom-modal"
      onClose={props.onClose}
    >
      <div className="bankOfferModal">
        <div className="bankOfferModal__header">
          <p>Bank Offer</p>
        </div>
        <div className="bankOfferModal__body">
          {paymentOffersList?.length
            ? paymentOffersList?.map((offer, index) => (
                <div className="bankOfferModal__list" key={index}>
                  <h3 className="bankOfferModal__list--header mt0">Offer {index + 1}</h3>
                  <p className="bankOfferModal__list--desc mv0">
                    {offer?.description ?? ''}
                  </p>
                </div>
              ))
            : null}
        </div>
      </div>
    </Modal>
  );
};

export default BankOfferModal;
